<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <h3 class="title">{{ headerTitle }}</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools" style="margin-bottom: 10px">
        <form-button style="margin-right: 10px" @click="$emit('back')">返回</form-button>

        <btky-header
          :form-data="wlyApplyForGoodsPo"
          :process-key="processKey"
          :terminalAdd="terminalAdd"
          :isTerminalType="isTerminalType"
          :isVerifyPlan="true"
          @formDataSave="validate(saveData)"
          @validate="validate"
          @startflow="startflow"
          @form-save="saveData"
          @advanceSuccess="advanceSuccess"
        />
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="110px"
        :show-message="false"
        :model="wlyApplyForGoodsPo"
        :disabled="isEdit"
        :rules="rules"
      >
        <common-title title="基本信息" />

        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="要货单号">
              <el-input
                v-model="wlyApplyForGoodsPo.wantCode"
                placeholder="自动生成"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="订单客户">
              <el-input v-model="wlyApplyForGoodsPo.customerName" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户">
              <el-input
                v-model="wlyApplyForGoodsPo.billCustomer"
                placeholder="请输入"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型" prop="planType">
              <el-select v-model="wlyApplyForGoodsPo.planType" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0002']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="制单票据类型">
              <el-select v-model="wlyApplyForGoodsPo.noticeSheetType" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0022']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 取经销商该年度签署合同渠道、如果不是配额计划，渠道为空 -->
            <el-col :lg="8" :md="12">
            <el-form-item
              prop="channelsType"
              label="渠道类型"
            >
              <el-select 
                v-model="wlyApplyForGoodsPo.channelsType" 
                @change="onChannelsTypeChange" 
                :disabled="isV032NormalApply"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in channelTypes"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item label="配额年度" prop="quotasYear">
              <el-input :value="wlyApplyForGoodsPo.quotasYear" disabled />
              <!-- <el-date-picker
                v-model="wlyApplyForGoodsPo.quotasYear"
                :clearable="false"
                format="yyyy"
                value-format="yyyy"
                type="year"
                placeholder="配额年度"
                disabled
              /> -->
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <el-select
                v-model="wlyApplyForGoodsPo.saleCenter"
                placeholder="请选择"
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in saleList"
                  :key="item.SOBID"
                  :value="item.SOBID"
                  :label="item.MC_SHORT"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="紧急程度" prop="significance">
              <el-select v-model="wlyApplyForGoodsPo.significance">
                <el-option
                  v-for="item in selectDataOptions['Significance']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否瓶储" prop="isPcj">
              <el-select v-model="wlyApplyForGoodsPo.isPcj" :disabled="isPcj">
                <el-option :value="0" label="否" />
                <el-option :value="1" label="是" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-show="wlyApplyForGoodsPo.isPcj == 1" :lg="8" :md="12">
            <el-form-item
              label="瓶储截止日期"
              :required="wlyApplyForGoodsPo.isPcj == 1 ? true : false"
            >
              <el-date-picker
                v-model="wlyApplyForGoodsPo.saveEnddate"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isCxj">
            <el-form-item label="是否存新酒" prop="isCxj">
              <el-select v-model="wlyApplyForGoodsPo.isCxj">
                <el-option
                  v-for="item in selectDataOptions['B0099']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-show="wlyApplyForGoodsPo.isCxj == 1" :lg="8" :md="12">
            <el-form-item
              label="储存期限(月)"
            >
              <el-input
                v-model="wlyApplyForGoodsPo.savedMonths"
                placeholder="请输入"
                type="number"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isTerminalType">
            <el-form-item label="要货单类型" prop="demandType">
              <el-select v-model="wlyApplyForGoodsPo.demandType" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0081']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isTerminalType">
            <el-form-item label="收货终端" prop="terminalName">
              <!-- <wly-input
                v-model="wlyApplyForGoodsPo.terminalName"
                input-type="terminal"
                :salesQueryParams="terminalQureyParams"
                @enter="handleInter"
                @handleSuffixClick="openSelectDialog($event, '终端选择')"
              /> -->
              <el-input
                  v-model="wlyApplyForGoodsPo.terminalName"
                  type="text"
                  clearable
                  suffix-icon="el-icon-more"
                @focus="openSelectDialog($event, 'terminal','终端名称')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="wlyApplyForGoodsPo.invoInfoid">
            <el-form-item label="发票号" prop="quotasYear">
              <el-input :value="wlyApplyForGoodsPo.invoInfoid" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="table-container" style="padding: 0">
          <TableCommon title="要货明细" :custome-config="() => vxeShowCustom('xTable')">
            <vxe-grid
              ref="xTable"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="auto"
              max-height="300"
              align="center"
              size="medium"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
              :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions.columns"
              :data="gridOptions.data"
            >
              <!-- <template #toolbar /> -->
              <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
                <div :key="item.field">
                  <el-input
                    v-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'wantQuantity'
                    "
                    v-model.number="row[item.field]"
                    size="mini"
                    :disabled="wlyApplyForGoodsPo.invoInfoid ? true : false"
                  />
                  <el-input
                    v-else-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'batchNumber'
                    "
                    v-model="row[item.field]"
                    size="mini"
                  />
                  <el-input
                    v-else-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'remark'
                    "
                    v-model="row[item.field]"
                    size="mini"
                  />
                </div>
              </template>
              <template #brandBq="{ row }">
                <span>{{ filterDictionary(row.brandBq, 'A0019') }}</span>
              </template>
            </vxe-grid>
          </TableCommon>

          <TableCommon
            v-if="isApplyForGoodsDetailShow == '1'"
            title="占用发票明细"
            :custome-config="() => vxeShowCustom('xTable2')"
          >
            <vxe-grid
              ref="xTable2"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="auto"
              max-height="240"
              align="center"
              size="mini"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
              :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions3.columns"
              :data="gridOptions3.data"
            >
              <!-- <template #toolbar /> -->
              <template v-for="item in gridOptions3.columns" #[item.field]="{ row }">
                <div :key="item.field">
                  <el-input
                    v-if="gridOptions3.columnsFieldTypes[item.field] == 'input'"
                    v-model="row[item.field]"
                  />
                  <span v-else>{{ row[item.field] }}</span>
                </div>
              </template>
            </vxe-grid>
          </TableCommon>

          <common-title title="收货信息" />
          <el-row :gutter="24">
            <!-- 是 分流经销商 分流收货单位 必填 -->
            <el-col :lg="8" :md="12" v-if="isTerminalType ? false : !isCxjBtn">
              <el-form-item label="是否分流：">
                <el-select v-model="wlyApplyForGoodsPo.isShunt" @change="shuntChange" :disabled="isV032NormalApply">
                  <el-option
                    v-for="item in selectDataOptions['B0099']"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 开票客户的分流经销商 -->
            <template v-if="wlyApplyForGoodsPo.isShunt === '1'">
              <el-col :lg="8" :md="12">
                <el-form-item label="分流经销商" prop="shuntDealer">
                  <el-input
                    v-model="wlyApplyForGoodsPo.shuntDealer"
                    placeholder="请输入"
                    type="text"
                    suffix-icon="el-icon-more"
                    clearable
                    @focus="showClientDialog($event, 'Shuntclient')"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="分流经销商名称" prop="shuntDealerName">
                  <el-input
                    v-model="wlyApplyForGoodsPo.shuntDealerName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="分流渠道类型" prop="shuntChannelsType">
                  <el-select v-model="wlyApplyForGoodsPo.shuntChannelsType">
                    <el-option
                      v-for="item in selectDataOptions['A0054']"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 开票客户的分流经销商 -->
              <el-col :lg="8" :md="12">
                <el-form-item label="分流收货单位" prop="shuntReceiveUnitName">
                  <el-input
                    v-model="wlyApplyForGoodsPo.shuntReceiveUnitName"
                    suffix-icon="el-icon-more"
                    clearable
                    @focus="showClientDialog($event, 'shuntContact')"
                  />
                </el-form-item>
              </el-col>
            </template>
            <!-- 默认订单客户 -->
            <el-col :lg="8" :md="12" v-if="!isCxjBtn">
              <el-form-item label="喷码单位">
                <el-input
                  v-model="wlyApplyForGoodsPo.spurtCodeUnitName"
                  placeholder="请输入"
                  :disabled="!$_has('WLY002')"
                  type="text"
                  clearable
                  suffix-icon="el-icon-more"
                  @clear="wlyApplyForGoodsPo.spurtCodeUnit = ''"
                  @focus="showClientDialog($event, 'client')"
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12" v-if="!isCxjBtn">
              <el-form-item label="喷码内容">
                <el-input
                  v-model="wlyApplyForGoodsPo.spurtCodeUnitName"
                  placeholder="请输入"
                  type="text"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <!-- 客户的收货地址 -->
            <el-col :lg="8" :md="12" v-if="!isCxjBtn">
              <el-form-item :label="isTerminalType ? '收货终端' :'收货单位'" prop="receiveUnitName">
                <el-input
                  v-model="wlyApplyForGoodsPo.receiveUnitName"
                  placeholder="请输入"
                  type="text"
                  clearable
                  :disabled="isselfacceptance || isTerminalType"
                  suffix-icon="el-icon-more"
                  @focus="showClientDialog($event, 'contact')"
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="收货联系人" prop="contacPerson">
                <el-input
                  v-model="wlyApplyForGoodsPo.contacPerson"
                  :disabled="!isTerminalType && !isV032NormalApply"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="联系电话" prop="contactNumber">
                <el-input
                  v-model="wlyApplyForGoodsPo.contactNumber"
                  :disabled="!isTerminalType && !isV032NormalApply"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :lg="16" :md="12">
              <el-form-item label="收货地址" prop="receiveAddress">
                <el-input
                  :value="wlyApplyForGoodsPo.receiveAddress"
                  disabled
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :lg="1" :md="1" class="edit-add" v-if="isTerminalType || isV032NormalApply">
              <span @click="openSelectDialog($event, 'receiveAddress','收货地址')">修改</span>
            </el-col>
            <!-- 是 备注必填 -->
            <el-col :lg="8" :md="12"  v-if="!isTerminalType">
              <el-form-item label="是否自提">
                <el-checkbox
                  v-model="wlyApplyForGoodsPo.selfacceptance"
                  :true-label="1"
                  :false-label="0"
                  @change="resetLinker"
                  :disabled="wlyApplyForGoodsPo.isCxj == 1"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  v-model="wlyApplyForGoodsPo.remark"
                  resize="none"
                  :disabled="isselfacceptance"
                  rows="3"
                  type="textarea"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 渠道类型选择KA时 -->
          <common-title v-if="wlyApplyForGoodsPo.channelsType == 'K'" title="KA卖场信息" />
          <el-row v-if="wlyApplyForGoodsPo.channelsType == 'K'" :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="卖场全称">
                <el-select
                  v-model="wlyApplyForGoodsPo.kaStoreFullname"
                  placeholder="请选择"
                  clearable
                  @focus="showClientDialog($event, 'ka')"
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="卖场简称">
                <el-input v-model="wlyApplyForGoodsPo.kaStoreShortName" disabled />
              </el-form-item>
            </el-col>
            <!-- 订单客户所在区域 -->
            <el-col :lg="8" :md="12">
              <el-form-item label="卖场区域">
                <el-input v-model="wlyApplyForGoodsPo.kaStoreArea" disabled />
              </el-form-item>
            </el-col>
          </el-row>

          <TableCommon title="附件" :custome-config="() => vxeShowCustom('xTable3')">
            <template #button>
              <el-upload
                ref="upload"
                action=""
                :on-change="uploadFile"
                :show-file-list="false"
                :auto-upload="false"
              >
                <table-button slot="trigger" name="upload" tip="上传" />
              </el-upload>
              <table-button name="delete" tip="删除" @click="delUpload" />
            </template>
            <vxe-grid
              ref="xTable3"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              align="center"
              size="mini"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
              :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions2.columns"
              :data="gridOptions2.data"
            >
              <template #fileName="{row}">
                <span class="blue" @click="dowLoadFile(row)">{{ row.fileName }}</span>
              </template>
              <template #createdDate="{row}">
                <span>{{ row.createdDate || row.creator.createdDate }}</span>
              </template>
            </vxe-grid>
          </TableCommon>
        </div>
      </el-form>
    </div>
    <div class="table-container">
      <btky-footer :form-data="wlyApplyForGoodsPo" />
    </div>

    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      :before-close="beforeClose"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <client-select v-if="showDialogType === 'client'" ref="dialogEdit" />
        <shunt-dealer-select v-if="showDialogType === 'Shuntclient' && !isRadio" ref="dialogEdit" :query-params="{customerCode: wlyApplyForGoodsPo.customerCode, type: 2}" />
        <shunt-dealer-all-select v-if="showDialogType === 'Shuntclient' && isRadio" ref="dialogEdit" mode="BP_ALL"/>
        <common-address
          v-if="showDialogType === 'contact' || showDialogType === 'shuntContact'"
          ref="dialogEdit"
          :partner="addressPartner"
        />
        <k-a-store v-if="showDialogType === 'ka'" ref="dialogEdit" :info="wlyApplyForGoodsPo" />
        <address-info v-if="showDialogType === 'addressInfo'" ref="dialogEdit" :partner="wlyApplyForGoodsPo.spurtCodeUnit" />
        <terminalAddress v-if="showDialogType === 'terminal'" :terminalQureyParams='terminalQureyParams' ref="dialogEdit" />
        <receiveAddress 
          v-if="showDialogType === 'receiveAddress' || showDialogType === 'commonReceiveAddress'" 
          ref="dialogEdit" 
          :address-data="showDialogType === 'commonReceiveAddress' ? commonAddressData : null"
          :area-type="showDialogType === 'commonReceiveAddress' ? '' : 'ZDZG'"
        />

      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="closeDialog"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="confirmSelect"
        >确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { webUploadFile, deleteFiles, queryFiles, apiAttachmentDownFile, } from '@/api/common'
import { getCutAddress } from '@/api/sap/client-sap'
import { apiGetOrgOrBase, getArea } from '@/api/sap/common-sap'
import {
  wantgoodsFindById,
  apiGetProdDeliveryPlan,
  apiGetProdMiddleStockData,
  getChannel,
  findShuntAnyByDealer,
  findFirstByTerminalId,
  queryDirectStore,
  queryPledgeQuantity
} from '@/api/applyForGoods/index'
import { handlerFlow, generateUUID } from '@/api/flowHander'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import ShuntDealerSelect from '@/components/dialog/ShuntDealerSelect.vue'
import ShuntDealerAllSelect from '@/components/dialog/ShuntDealerAllSelect.vue'
import CommonAddress from '@/components/dialog/CommonAddress.vue'
import KAStore from '@/components/dialog/KAStoreSelect.vue'
import AddressInfo from './AddressInfo.vue'
import terminalAddress from './terminalAddress.vue'
import receiveAddress from './receiveAddress.vue'
import { mapGetters } from 'vuex'
import { filterDictionary } from '@/utils/index'
import { download } from '@/utils/frontExport'

export default {
  name: 'to-goods',
  components: {
    ClientSelect,
    ShuntDealerSelect,
    ShuntDealerAllSelect,
    CommonAddress,
    KAStore,
    AddressInfo,
    terminalAddress,
    receiveAddress
  },
  props: {
    rowData: {
      type: Object,
      default: () => {}
    },
    distributeCustList: {
      type: Object,
      default: () => {}
    },
    sourceType: {
      type: String,
      default: 'common'
    }
  },
  data() {
    return {
      isRadio: false,
      errorList: [],
      isPcj: false,
      processKey: 'wantGoods',
      chooseChannel: 0,
      saleList: [],
      isClient: '0',
      showDialog: false,
      showDialogType: '',
      dialogTitle: '',
      channelTypes: [],
      pickerOptions: {
        disabledDate: (time) => {
          const date = new Date()
          date.setDate(date.getDate() - 1)
          return time.getTime() < date.getTime()
        }
      },
      rules: {
        channelsType: [{ required: true, message: '请选择渠道类型', trigger: 'change' }],
        significance: [{ required: true, message: '请选择紧急程度', trigger: 'change' }],
        receiveUnitName: [{ required: true, message: '请选择收货单位名称', trigger: 'change' }],
        contactNumber: [{ required: true, message: '请输入联系电话', trigger: 'change' }],
        contacPerson: [{ required: true, message: '请输入联系人', trigger: 'change' }],
        receiveAddress: [{ required: true, message: '请输入收货地址', trigger: 'change' }],
        isPcj: [{ required: true, message: '请选择是否瓶储酒', trigger: 'change' }],
        shuntDealer: [{ required: true, message: '请选择分流经销商', trigger: 'change' }],
        shuntReceiveUnitName: [{ required: true, message: '请选择分流收货单位', trigger: 'change' }],
        shuntChannelsType: [{ required: true, message: '请选择分流渠道类型', trigger: 'change' }],
        terminalName: [{ required: true, message: '请选择终端', trigger: 'change' }],
      },
      terminalAdd: {
        REGION: '',
        REGION_TEXT: '',
        CITY_CODE: '',
        CITY_TEXT: '',
        STREET_CODE: '',
        STREET_TEXT: '',
        STREET: ''
      },
      wlyApplyForGoodsPo: {
        id: '',
        taskId: '',
        bizId: '',
        status: 0,
        billCode: '',
        isPcj: 0,
        isCxj: '0',
        saveTimes: 0,
        billStatus: 'E001',
        bizCode: 'wantGoods',
        fileBizId: '',
        cancelDays: '',
        billCustCode: '',
        billCustomer: '',
        shuntDealer: '',
        shuntDealerName: '',
        clientId: '',
        brandBq: '',
        ticketDetailId: '',
        remark: '',
        customerCode: '',
        customerName: '',
        noticeSheetType: '',
        receiveUnitCode: '',
        channelsType: '',
        quotasYear: '',
        saleCenter: '', // 营销单元
        saleCenterName: '',
        isShunt: '0',
        significance: 'normal',
        kaStoreShortName: '',
        kaStoreFullname: '',
        kaStoreArea: '',
        acceptUnitType: '',
        receiveUnitName: '',
        cityCode: '',
        cityName: '',
        region: '',
        streetcode: '',
        province: '',
        city: '',
        district: '',
        provinceId: '',
        cityId: '',
        districtId: '',
        receiveCityCode: '',
        receiveCityName: '',
        receiveAddress: '',
        contacPerson: '',
        contactNumber: '',
        shuntChannelsType: '',
        shuntReceiveUnitCode: '',
        shuntReceiveUnitName: '',
        spurtCodeUnit: '',
        spurtCodeUnitName: '',
        selfacceptance: 0,
        ggtg: '0',
        transferId: '',
        sourceType: '1',
        saveEnddate: '',
        zdggtg: '',
        demandType: '',
        terminalId: '',
        terminalName: ''
      },
      // resBrand:{},
      selectDataOptions: {
        cityList: [],
        streetList: [],
        regionList: []
      },
      selectChannelOptions: {},
      selectSaleCenterOptions: {},
      selectReceiveAddressOptions: {},
      receiveAddressTemp: {},
      loading: false,
      pagination: {
        totalCount: 0,
        page: 1,
        pagesize: 50
      },
      gridOptions: {
        columns: [
          {
            field: 'brandBqDesc',
            title: '存货分类',
            width: 120
          },
          // {
          //  field: 'brandBqName',
          //   title: '品牌名称',
          //   width: 120
          //  },
          {
            field: 'ticketDetailId',
            title: '发票明细ID',
            width: 120,
            visible: false
          },
          {
            field: 'productCode',
            title: '产品编号',
            width: 200
          },
          {
            field: 'productDesc',
            title: '产品名称',
            width: 300
          },
          {
            field: 'undeliveredQuantity',
            title: '未发货量(件)',
            width: 90
          },
          {
            field: 'availableBot',
            title: '未发货量(瓶)',
            width: 90
          },
          {
            field: 'releaseBot',
            title: '可放行数量',
            width: 90
          },
          {
            field: 'wantQuantity',
            title: '*本次要货量(件)',
            width: 90,
            slots: { default: 'wantQuantity' }
          },
          {
            field: 'salecenterAuditQuantity',
            title: '销售内勤审批数量',
            width: 120,
            visible: false
          },
          {
            field: 'stockQuantity',
            title: '库存量',
            width: 120,
            visible: false
          },
          {
            field: 'roadQuantity',
            title: '在途量',
            width: 120,
            visible: false
          },
          {
            field: 'auditShipmentQuantity',
            title: '已审在发运量',
            width: 120,
            visible: false
          },
          {
            field: 'yearSalePlanQty',
            title: '年销售计划量',
            width: 120,
            visible: false
          },
          {
            field: 'monthSalePlanQty',
            title: '月销售计划量',
            width: 120,
            visible: false
          },
          {
            field: 'monthAuditQty',
            title: '当月审批量',
            width: 120,
            visible: false
          },
          {
            field: 'remark',
            title: '备注',
            // width: 100,
            slots: { default: 'remark' }
          }
        ],
        data: [],
        columnsFieldTypes: { batchNumber: 'input',remark: 'input', wantQuantity: 'input' }
      },
      gridOptions3: {
        columns: [
          { type: 'seq', title: '序号', filed: 'seq', width: 60 },
          {
            field: 'custName',
            title: '开票客户',
            width: 180
          },
          {
            field: 'invoiceDate',
            title: '开票日期',
            width: 120
          },
          {
            field: 'invoId',
            title: '发票号',
            width: 120
          },
          {
            field: 'productText',
            title: '产品名称',
            width: 220
          },
          {
            field: 'invoiceQty',
            title: '开票总量(件)',
            width: 120
          },
          {
            field: 'datum',
            title: '占用时间',
            width: 150
          },
          {
            field: 'occupyQty',
            title: '本次占用(件)',
            width: 100
          }
        ],
        data: []
      },
      gridOptions2: {
        columns: [
          { type: 'radio', title: '#', filed: 'radio', width: 50 },
          {
            field: 'fileName',
            title: '附件名称',
            slots: { default: 'fileName' }
          },
          {
            field: 'fileKind',
            title: '附件类型'
          },
          {
            field: 'fileSize',
            title: '大小'
          },
          {
            field: 'createdDate',
            title: '上传时间',
            slots: { default: 'createdDate' }
          }
        ],
        data: []
      },
      terminalRobotArrs: [],
      terminalQureyParams: {},
      commonAddressData: {
        REGION: '',
        REGION_TEXT: '',
        CITY_CODE: '',
        CITY_TEXT: '',
        STREET_CODE: '',
        STREET_TEXT: '',
        STREET: ''
      }
    }
  },
  computed: {
    isTerminalType() {
      return this.sourceType == 'terminal' || this.wlyApplyForGoodsPo.demandType == 'ZDZG'
    },
    headerTitle() {
      return this.isTerminalType ? '终端直配发货申请表' : '发货申请表'
    },
    // 是否为V032客户类型且为普通要货申请
    isV032NormalApply() {
      const customerType = this.customerInfo?.info?.zzfld000016
      return customerType === 'V032' && !this.isTerminalType
    },
    isCxjBtn(){
      if(this.isCxj){
        return this.wlyApplyForGoodsPo.isCxj == 1
      }
      return false
    },
    isCxj(){
      return this.role.CXJ_ROLE === 'X'
    },
    isEdit() {
      if (this.wlyApplyForGoodsPo.saveTimes === 1) {
        return true
      }
      return false
    },
    // 是否是自提
    isselfacceptance() {
      return this.wlyApplyForGoodsPo.selfacceptance === '1'
    },
    // 审批、单据查询 出现
    isApplyForGoodsDetailShow() {
      return this.$route.query.isSearchPage
    },
    addressPartner() {
      if (this.showDialogType === 'shuntContact') {
        return this.wlyApplyForGoodsPo.shuntDealer
      }
      return this.wlyApplyForGoodsPo.spurtCodeUnit
    },
    ...mapGetters(['userInfo', 'role', 'customerInfo'])
  },
  watch: {
    // 监听渠道类型列表变化，如果是V032客户类型，自动设置默认值
    channelTypes: {
      handler(newVal) {
        if (this.isV032NormalApply && newVal && newVal.length > 0) {
          const hasH = newVal.some(item => item.value === 'H')
          if (hasH && (!this.wlyApplyForGoodsPo.channelsType || this.wlyApplyForGoodsPo.channelsType !== 'H')) {
            this.$set(this.wlyApplyForGoodsPo, 'channelsType', 'H')
          }
        }
      },
      immediate: true
    },
    // 监听customerInfo变化，确保在加载完成后设置默认值
    customerInfo: {
      handler(newVal) {
        const customerType = newVal?.info?.zzfld000016
        if (customerType === 'V032' && !this.isTerminalType && this.channelTypes && this.channelTypes.length > 0) {
          const hasH = this.channelTypes.some(item => item.value === 'H')
          if (hasH && (!this.wlyApplyForGoodsPo.channelsType || this.wlyApplyForGoodsPo.channelsType !== 'H')) {
            this.$set(this.wlyApplyForGoodsPo, 'channelsType', 'H')
          }
        }
      },
      immediate: true,
      deep: true
    },
    'gridOptions.data': {
      handler(val) {
        this.wlyApplyForGoodsPo.wantGoodsDetailList = val
      },
      deep: true
    },
    // 'gridOptions2.data': {
    //   handler(val) {
    //     this.wlyApplyForGoodsPo.attachmentList = val
    //   },
    //   deep: true
    // },
    'wlyApplyForGoodsPo.isCxj':{
      handler(val) {
        if(val == '1'){
          // V032客户类型优先级最高，不覆盖
          if (!this.isV032NormalApply) {
            this.channelTypes = [{ value: 'C', name: '存新酒渠道' }]
            this.wlyApplyForGoodsPo.channelsType = 'C'
          }
          this.wlyApplyForGoodsPo.isPcj = 0
          this.isPcj = true
          // this.isselfacceptance = true
        }else{
          this.isPcj = false
          // this.isselfacceptance = false
          // V032客户类型优先级最高，不覆盖
          if (!this.isV032NormalApply) {
            this.wlyApplyForGoodsPo.channelsType = ''
          }
          this.getChannelType()
        }
        this.setAddress(this.wlyApplyForGoodsPo.customerCode)
      }

    },
    'wlyApplyForGoodsPo.isShunt': {
      handler(val) {
        if (val === '0') {
          this.wlyApplyForGoodsPo.shuntReceiveUnitName = ''
          this.wlyApplyForGoodsPo.shuntReceiveUnitCode = ''
          this.wlyApplyForGoodsPo.shuntChannelsType = ''
          this.wlyApplyForGoodsPo.shuntDealer = ''
          this.wlyApplyForGoodsPo.shuntDealerName = ''
          if (this.rowData.transferClient === undefined) {
            this.setAddress(this.rowData.orderCust)
            this.wlyApplyForGoodsPo.spurtCodeUnit = this.rowData.orderCust
            this.wlyApplyForGoodsPo.spurtCodeUnitName = this.rowData.orderCustName
          } else {
            this.setAddress(this.rowData.receiveClientCode)
            this.wlyApplyForGoodsPo.spurtCodeUnit = this.rowData.receiveClientCode
            this.wlyApplyForGoodsPo.spurtCodeUnitName = this.rowData.receiveClient
          }
        }
      }
    }
  },
  mounted() {
    // 在mounted中再次检查并设置V032客户类型的渠道类型默认值
    this.$nextTick(() => {
      if (this.isV032NormalApply && this.channelTypes && this.channelTypes.length > 0) {
        const hasH = this.channelTypes.some(item => item.value === 'H')
        if (hasH) {
          this.$set(this.wlyApplyForGoodsPo, 'channelsType', 'H')
          // 延迟再次确认
          setTimeout(() => {
            if (this.wlyApplyForGoodsPo.channelsType !== 'H') {
              this.$set(this.wlyApplyForGoodsPo, 'channelsType', 'H')
              this.$forceUpdate()
            }
          }, 300)
        }
      }
    })
  },
  created() {
    this.init()
    // 如果是从待办中进入的申请单，直接查询已保存的发货申请单
    if (this.$route.query && this.$route.query.id) {
      this.getToGoodsPo()
    } else {
      this.wlyApplyForGoodsPo.invoInfoid = this.rowData.invoId || ''
      this.wlyApplyForGoodsPo.quotasYear = this.rowData.annual + ''
      this.wlyApplyForGoodsPo.planType = this.rowData.zZFLD00002Q
      this.wlyApplyForGoodsPo.customerCode = this.rowData.orderCust
      this.wlyApplyForGoodsPo.customerName = this.rowData.orderCustName
      // 存货分类
      this.wlyApplyForGoodsPo.brandBq = this.rowData.brandBq
      // this.gridOptions.data = [{ ...this.rowData, wantQuantity: '' }]
      this.setAddress(this.rowData.orderCust)
      if (this.rowData.transferClient === undefined) {
        // 普通要货
        this.wlyApplyForGoodsPo.zdggtg = this.rowData.acceptUnitType
        this.wlyApplyForGoodsPo.acceptUnitType = this.rowData.acceptUnitType
        this.wlyApplyForGoodsPo.ticketDetailId = this.rowData.ticketDetailId
        this.wlyApplyForGoodsPo.spurtCodeUnit = this.rowData.orderCust
        this.wlyApplyForGoodsPo.spurtCodeUnitName = this.rowData.orderCustName
        // 存新酒
        // if(this.rowData.sourceType == '3'){
        //   this.wlyApplyForGoodsPo.sourceType = '3'
        // }
      } else {
        // 货权转移的要货申请
        this.wlyApplyForGoodsPo.sourceType = '2'
        // console.log('this.rowData=====', this.rowData)
        this.wlyApplyForGoodsPo.transferId = this.rowData.transferId
        this.wlyApplyForGoodsPo.spurtCodeUnit = this.rowData.receiveClientCode
        this.wlyApplyForGoodsPo.spurtCodeUnitName = this.rowData.receiveClient
        this.wlyApplyForGoodsPo.customerCode = this.rowData.receiveClientCode
        this.wlyApplyForGoodsPo.customerName = this.rowData.receiveClient
        this.wlyApplyForGoodsPo.receiveUnitCode = this.rowData.receiveClientCode
        this.wlyApplyForGoodsPo.receiveUnitName = this.rowData.receiveClient
          this.setAddress(this.rowData.receiveClientCode)
        // getCutAddress({ partner: this.rowData.receiveClientCode }).then(res => {
        //   if (res.data?.length) {
        //     this.wlyApplyForGoodsPo.receiveAddress = res.data[0].street
        //     this.wlyApplyForGoodsPo.contacPerson = res.data[0].c_o_name
        //     this.wlyApplyForGoodsPo.contactNumber = res.data[0].tel_number
        //     this.wlyApplyForGoodsPo.receiveUnitName = res.data[0].partner_name
        //     this.wlyApplyForGoodsPo.cityCode = res.data[0].city_code
        //     this.wlyApplyForGoodsPo.cityName = res.data[0].city_name
        //     this.wlyApplyForGoodsPo.receiveCityName = res.data[0].city_name
        //     this.wlyApplyForGoodsPo.receiveCityCode = res.data[0].city_code
        //   }
        // })
      }
      this.wlyApplyForGoodsPo.noticeSheetType = this.rowData.infType
      this.wlyApplyForGoodsPo.billCustCode = this.rowData.customer
      this.wlyApplyForGoodsPo.billCustomer = this.rowData.custName
      this.wlyApplyForGoodsPo.saleCenter = this.rowData.zzfld000001
      this.gridOptions.data = [{ ...this.rowData, wantQuantity: '' }]

      // 瓶储酒计划,喷码单位：空
      if (this.wlyApplyForGoodsPo.planType === 'V036') {
        this.wlyApplyForGoodsPo.spurtCodeUnit = ''
        this.wlyApplyForGoodsPo.spurtCodeUnitName = ''
        this.wlyApplyForGoodsPo.receiveAddress = '四川省安吉物流公司西南区域中心仓-2'
        this.wlyApplyForGoodsPo.contacPerson = ''
        this.wlyApplyForGoodsPo.contactNumber = ''
      }
      if(this.wlyApplyForGoodsPo.invoInfoid){
        this.gridOptions.data[0].wantQuantity = this.rowData.availableQty
      }
      this.gridOptions.data[0].undeliveredQuantity = this.rowData.availableQty
      // 产品为经典201（产品代码：4000001397） 且 为非配额类型（ZB03）, 则渠道类型强制为:社会化终端
      // 但V032客户类型优先级更高，不设置
      if (this.rowData.productCode === '4000001397' && this.rowData.zZFLD00002Q === 'ZB03' && !this.isV032NormalApply) {
        this.wlyApplyForGoodsPo.channelsType = 'S'
      }
      if (this.rowData.zzfld000001 === '0005000210') {
        this.isPcj = true
        this.wlyApplyForGoodsPo.isPcj = 1
      } else {
        this.wlyApplyForGoodsPo.isPcj = 0
      }
      // 获取生成文件id
      generateUUID().then(res => {
        this.wlyApplyForGoodsPo.fileBizId = res.data
      })
      this.getProdDeliveryPlan()
      // 渠道类型
      this.getChannelType()
      // 可放行数量
      this.getPledgeQuantity()
      // V032客户类型且为普通要货申请，设置是否分流为否
      if (this.isV032NormalApply) {
        this.$set(this.wlyApplyForGoodsPo, 'isShunt', '0')
      }
    }
    if(this.rowData.needBatch - 0 === 1){
      this.gridOptions.columns.splice(this.gridOptions.columns.length - 1, 0, {
            field: 'batchNumber',
            title: '批次号',
            width: 120,
            slots: { default: 'batchNumber' }
          })
    }
    apiGetOrgOrBase().then(res => {
      this.saleList = res.DATA
      this.selectSaleOrg(this.wlyApplyForGoodsPo.saleCenter)
    })
    if(this.sourceType == 'terminal' ){
      this.wlyApplyForGoodsPo.demandType = 'ZDZG'
    }
  },

  methods: {
    // 渠道类型变化处理
    onChannelsTypeChange(value) {
      if(this.isTerminalType){
        this.wlyApplyForGoodsPo.terminalName = ''
        this.wlyApplyForGoodsPo.terminalId = ''
        this.wlyApplyForGoodsPo.receiveUnitName = ''
        this.wlyApplyForGoodsPo.receiveAddress = ''
        this.wlyApplyForGoodsPo.contactNumber = ''
        this.wlyApplyForGoodsPo.contacPerson = ''
        this.wlyApplyForGoodsPo.province = ''
        this.wlyApplyForGoodsPo.city = ''
        this.wlyApplyForGoodsPo.district = ''

        // 清空终端地址信息
        this.terminalAdd = {
          REGION: '',
          REGION_TEXT: '',
          CITY_CODE: '',
          CITY_TEXT: '',
          STREET_CODE: '',
          STREET_TEXT: '',
          STREET: ''
        }
      }
    },
    // 打开窗口
    openSelectDialog(e, type, name) {
      if(type === 'receiveAddress') {
        // 如果是V032普通要货申请，准备地址数据并设置areaType为空
        if (this.isV032NormalApply) {
          this.commonAddressData = {
            REGION: this.wlyApplyForGoodsPo.region || '',
            REGION_TEXT: '',
            CITY_CODE: this.wlyApplyForGoodsPo.cityCode || '',
            CITY_TEXT: this.wlyApplyForGoodsPo.cityName || '',
            STREET_CODE: this.wlyApplyForGoodsPo.streetcode || '',
            STREET_TEXT: '',
            STREET: this.wlyApplyForGoodsPo.receiveAddress || ''
          }
          this.showDialogType = 'commonReceiveAddress'
        } else {
          // 终端直配，使用默认的 receiveAddress
          this.showDialogType = 'receiveAddress'
        }
        this.dialogTitle = name
        this.showDialog = true
        return
      }
      if(!this.wlyApplyForGoodsPo.channelsType){
        this.$message.error("请选择渠道类型")
        return
      }
      this.terminalQureyParams.channelType=this.wlyApplyForGoodsPo.channelsType;
      e.target.blur()
      this.showDialogType = type
      this.dialogTitle = name
      this.showDialog = true
    },
    editTerminalAdd(data){
      this.wlyApplyForGoodsPo.terminalName = data.storeName
      this.wlyApplyForGoodsPo.terminalId = data.storeId
      this.wlyApplyForGoodsPo.receiveUnitName = data.storeName
      this.wlyApplyForGoodsPo.receiveAddress = (data.provinceName + data.cityName + data.districtName + data.address) || ''
      this.wlyApplyForGoodsPo.contactNumber = data.consigneePhone
      this.wlyApplyForGoodsPo.contacPerson = data.consignee
      this.wlyApplyForGoodsPo.province = data.provinceName
      this.wlyApplyForGoodsPo.city = data.cityName
      this.wlyApplyForGoodsPo.district = data.districtName
      // this.wlyApplyForGoodsPo.receiveUnitCode = data.storeId
      // this.changeTerminal(data.storeId)
    },
    async handleInter(e, type, res) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      this.wlyApplyForGoodsPo.terminalName = res.data[0].storeName
      this.wlyApplyForGoodsPo.terminalId = res.data[0].storeId
      this.wlyApplyForGoodsPo.receiveUnitName = res.data[0].storeName
      // this.wlyApplyForGoodsPo.receiveUnitCode = res.data[0].storeId
      // this.changeTerminal(res.data[0].storeId)
    },
    // 请求历史收货地址
    changeTerminal(e){
      findFirstByTerminalId({terminalId: e}).then(res => {
        this.wlyApplyForGoodsPo.receiveAddress = res.data.receiveAddress
        this.wlyApplyForGoodsPo.contactNumber = res.data.contactNumber
        this.wlyApplyForGoodsPo.contacPerson = res.data.contacPerson
        this.wlyApplyForGoodsPo.province = res.data.province
        this.wlyApplyForGoodsPo.city = res.data.city
        this.wlyApplyForGoodsPo.district = res.data.district
      })
    },
    // 收货终端
    getTerminalRobot(inventoryCode){
      const params = {
        dealerId: this.wlyApplyForGoodsPo.customerCode,
        inventoryCode,
      }

      queryDirectStore(params).then(res => {
        this.terminalRobotArrs = res.data.data
      })
    },
    // 省
    getAreaArr(){
      getArea('','region',"ZDZG").then(res => {
        this.selectDataOptions['regionList'] = res.DATA
      })
    },
    async changeStreet(e){
      this.terminalAdd = {...e}
      this.wlyApplyForGoodsPo.receiveAddress = e.REGION_TEXT + e.CITY_TEXT + e.STREET_TEXT + e.STREET
    },
    // V032普通要货申请修改收货地址
    changeCommonAddress(data) {
      if (data) {
        this.wlyApplyForGoodsPo.region = data.REGION
        this.wlyApplyForGoodsPo.cityCode = data.CITY_CODE
        this.wlyApplyForGoodsPo.cityName = data.CITY_TEXT
        this.wlyApplyForGoodsPo.streetcode = data.STREET_CODE
        this.wlyApplyForGoodsPo.receiveAddress = (data.REGION_TEXT || '') + (data.CITY_TEXT || '') + (data.STREET_TEXT || '') + (data.STREET || '')
        // 保存省市区名称和编码，用于行业团购时传递到后端
        this.wlyApplyForGoodsPo.province = data.REGION_TEXT || ''
        this.wlyApplyForGoodsPo.city = data.CITY_TEXT || ''
        this.wlyApplyForGoodsPo.district = data.STREET_TEXT || ''
        this.wlyApplyForGoodsPo.provinceId = data.REGION || ''
        this.wlyApplyForGoodsPo.cityId = data.CITY_CODE || ''
        this.wlyApplyForGoodsPo.districtId = data.STREET_CODE || ''
      }
    },
    async shuntChange(e){
      if(e - 0 === 1){
        const res = await findShuntAnyByDealer({customerCode: this.role.USER_BP})
        this.isRadio = res.data - 0 === 1
      }
    },
    filterDictionary,
    async setAddress(partner) {
      const params = {
        partner,
        mode: this.wlyApplyForGoodsPo.isCxj == 1 ? 'CXJ' : ''
      }
      const res = await getCutAddress(params)
      if (res.DATA?.length) {
        const addressData = res.DATA[0]
        this.wlyApplyForGoodsPo.receiveAddress = addressData.STREET
        this.wlyApplyForGoodsPo.contacPerson = addressData.C_O_NAME
        this.wlyApplyForGoodsPo.contactNumber = addressData.TEL_NUMBER
        this.wlyApplyForGoodsPo.receiveUnitName = addressData.PARTNER_NAME
        this.wlyApplyForGoodsPo.receiveUnitCode = addressData.PARTNER
        this.wlyApplyForGoodsPo.cityCode = addressData.CITY_CODE
        this.wlyApplyForGoodsPo.cityName = addressData.CITY_NAME
        this.wlyApplyForGoodsPo.receiveCityName = addressData.CITY_NAME
        this.wlyApplyForGoodsPo.receiveCityCode = addressData.CITY_CODE
        this.wlyApplyForGoodsPo.region = addressData.REGION
        this.wlyApplyForGoodsPo.streetcode = addressData.STREETCODE
        
        // V032普通要货申请，需要保存省市区名称和编码用于行业团购
        if (this.isV032NormalApply) {
          // 保存编码
          this.wlyApplyForGoodsPo.provinceId = addressData.REGION || ''
          this.wlyApplyForGoodsPo.cityId = addressData.CITY_CODE || ''
          this.wlyApplyForGoodsPo.districtId = addressData.STREETCODE || ''
          
          // 如果有名称字段，直接使用；否则根据编码查询名称
          if (addressData.REGION_TEXT) {
            this.wlyApplyForGoodsPo.province = addressData.REGION_TEXT
          } else if (addressData.REGION) {
            // 根据省编码查询省名称
            const regionRes = await getArea('', 'region')
            const regionItem = regionRes.DATA?.find(item => item.BLAND === addressData.REGION)
            this.wlyApplyForGoodsPo.province = regionItem?.BEZEI || ''
          }
          
          // 市名称
          this.wlyApplyForGoodsPo.city = addressData.CITY_NAME || ''
          
          // 区名称需要根据区编码查询
          if (addressData.STREETCODE && addressData.CITY_CODE) {
            const streetRes = await getArea(addressData.CITY_CODE, 'street')
            const streetItem = streetRes.DATA?.find(item => item.STRT_CODE === addressData.STREETCODE)
            this.wlyApplyForGoodsPo.district = streetItem?.MC_STREET || ''
          }
        }
        
        if(this.isTerminalType){
          this.wlyApplyForGoodsPo.contactNumber = ''
          this.wlyApplyForGoodsPo.contacPerson = ''
          this.wlyApplyForGoodsPo.receiveAddress = ''
          this.wlyApplyForGoodsPo.receiveUnitName = ''
        }
      }
    },
    startflow(data) {
      const {taskId,procInstId, id } = this.wlyApplyForGoodsPo
      Object.assign(this.wlyApplyForGoodsPo, data.bizData)
      if (data.bizId) {
        // 启动流程
        this.id = data.bizId
        this.wlyApplyForGoodsPo.id = data.bizId
        this.wlyApplyForGoodsPo.bizId = data.bizId
        this.wlyApplyForGoodsPo.taskId = data.taskId
        this.wlyApplyForGoodsPo.procInstId = data.bizprocInstId
      } else {
        // 保存
        this.wlyApplyForGoodsPo.id = id
        this.wlyApplyForGoodsPo.taskId = id
        this.wlyApplyForGoodsPo.taskId = taskId
        this.wlyApplyForGoodsPo.procInstId = procInstId
      }
      // this.wlyApplyForGoodsPo.id = data.bizId
      // this.wlyApplyForGoodsPo.bizId = data.bizId
      // this.wlyApplyForGoodsPo.taskId = data.taskId
      // this.wlyApplyForGoodsPo.procInstId = data.bizprocInstId
      this.wlyApplyForGoodsPo.billCode = data.bizData.billCode
      this.wlyApplyForGoodsPo.billStatus = data.bizData.billStatus
      this.wlyApplyForGoodsPo.createdByName = data.bizData.createdByName
      this.gridOptions.data = data.bizData.wantGoodsDetailList
    },
    init() {
      // 计划类型
      this.getSelectDictDataOrigin('A0002')
      // 通知单类型
      this.getSelectDictDataOrigin('A0022')
      // 是否分流
      this.getSelectDictDataOrigin('B0099')
      // 渠道类型
      this.getSelectDictDataOrigin('A0054')
      // 存货分类
      this.getSelectDictDataOrigin('A0019')
      // 要货类型
      this.getSelectDictDataOrigin('A0081')
      // 发货紧急程度
      this.getSelectDictDataOrigin('Significance')
    },
    getChannelType() {
      // getChannel({ salePlan: this.wlyApplyForGoodsPo.planType }).then(response => {

      this.terminalQureyParams.customerCode=this.wlyApplyForGoodsPo.customerCode;
      var tempParam = {
        salePlan: this.wlyApplyForGoodsPo.planType,
        productCode: this.rowData.productCode,
        customerCode: this.wlyApplyForGoodsPo.customerCode
      }
      if(this.isTerminalType){
        tempParam.isTerminal = true;
      }
      // 受让货权转移产品要货入口查询所有渠道类型
      if (this.wlyApplyForGoodsPo.sourceType == '2') {
        tempParam.queryAllChannels = true;
      }
      // 先检查V032客户类型且为普通要货申请，优先级最高
      const customerType = this.customerInfo?.info?.zzfld000016
      const isV032Normal = customerType === 'V032' && !this.isTerminalType
      
      getChannel(tempParam).then(response => {
        if (response) {
          this.channelTypes = response.data || []
          // if (this.wlyApplyForGoodsPo.zdggtg =='V013'||this.wlyApplyForGoodsPo.zdggtg =='V015'){
          //   this.channelTypes = [{ value: 'T', name: '团购渠道' }]
          // }
          
          // V032客户类型且为普通要货申请，优先级最高，覆盖其他逻辑
          if (isV032Normal) {
            const hasH = this.channelTypes.some(item => item.value === 'H')
            if (!hasH) {
              this.channelTypes.push({ value: 'H', name: '行业团购' })
            }
            // 只保留H选项，其他选项移除
            this.channelTypes = [{ value: 'H', name: '行业团购' }]
            // 设置默认值为H，使用$set确保响应式更新
            this.$set(this.wlyApplyForGoodsPo, 'channelsType', 'H')
            console.log('V032设置渠道类型为H:', this.wlyApplyForGoodsPo.channelsType)
            // 强制更新视图
            this.$forceUpdate()
            // 在nextTick中再次确认，防止被其他逻辑覆盖
            this.$nextTick(() => {
              this.$set(this.wlyApplyForGoodsPo, 'channelsType', 'H')
              console.log('nextTick后渠道类型:', this.wlyApplyForGoodsPo.channelsType)
              // 延迟再次确认，确保DOM已更新
              setTimeout(() => {
                if (this.wlyApplyForGoodsPo.channelsType !== 'H') {
                  console.log('延迟检查，重新设置渠道类型为H')
                  this.$set(this.wlyApplyForGoodsPo, 'channelsType', 'H')
                  this.$forceUpdate()
                } else {
                  console.log('渠道类型已正确设置为H')
                }
              }, 200)
            })
          } else {
            // 非V032客户类型，执行原有逻辑
            if (this.wlyApplyForGoodsPo.acceptUnitType == 'V014') {
              this.channelTypes = [{ value: 'Z', name: '终端团购渠道' }]
            }
            if (!this.channelTypes.length) {
              this.channelTypes = [{ value: 'S', name: '社会化渠道' }]
            }
          }
        }
      }).catch(() => {
        // 如果接口调用失败，V032客户类型且为普通要货申请时，至少保证有H选项
        if (isV032Normal) {
          this.channelTypes = [{ value: 'H', name: '行业团购' }]
          this.$set(this.wlyApplyForGoodsPo, 'channelsType', 'H')
        }
      })
    },
    // 选择销售单元
    selectSaleOrg(val) {
      var obj = {}
      obj = this.saleList.find(item => {
        return item.SOBID === val
      })
      this.wlyApplyForGoodsPo.saleCenterName = obj?.MC_SHORT
    },
    // 根据id查询发货单信息
    getToGoodsPo() {
      wantgoodsFindById({ id: this.$route.query.id }).then(response => {
        this.wlyApplyForGoodsPo = response.data
        this.wlyApplyForGoodsPo.bizId = response.data.id
        this.$route.query.taskId && (this.wlyApplyForGoodsPo.taskId = this.$route.query.taskId)
        this.wlyApplyForGoodsPo.quotasYear = response.data.quotasYear + ''
        this.wlyApplyForGoodsPo.isShunt = response.data.isShunt + ''
        this.gridOptions.data = this.wlyApplyForGoodsPo.wantGoodsDetailList
        if(this.wlyApplyForGoodsPo.wantGoodsDetailList[0].batchNumber){
          this.gridOptions.columns.splice(this.gridOptions.columns.length - 1, 0, {
            field: 'batchNumber',
            title: '批次号',
            width: 120,
            slots: { default: 'batchNumber' }
          })
        }
        this.gridOptions3.data = this.wlyApplyForGoodsPo.invoiceUsedList
        this.getFiles()
        // 渠道类型
        this.getChannelType()
        // 终端要货
        if(this.isTerminalType){
          this.wlyApplyForGoodsPo.demandType == 'ZDZG'
          // 初始化省份
          // this.getAreaArr()
          this.terminalQureyParams = {
            dealerId: this.wlyApplyForGoodsPo.customerCode,
            inventoryCode: this.wlyApplyForGoodsPo.brand
          }
          // this.getTerminalRobot()
        }
        if (this.wlyApplyForGoodsPo.status === 3) {
          this.gridOptions.columns = this.gridOptions.columns.map(v => {
            if (v.field === 'salecenterAuditQuantity' || v.field === 'salecenterAuditQuantity') {
              v.visible = true
            }
            return v
          })
          this.$refs.xTable.refreshColumn()
        }
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    async getPledgeQuantity(){
      const { productCode, productDesc,custName } = this.rowData
      const params = {
        customerCode: this.wlyApplyForGoodsPo.billCustCode,
        customerName: this.wlyApplyForGoodsPo.billCustomer,
        productCode,
        productName: productDesc,
      }
      try {
        const {data} = await queryPledgeQuantity(params)
        this.gridOptions.data.forEach(item => {
          this.$set(item, 'releaseBot', data.quantity)
        })
      } catch (error) {

      }
    },
    // 经销商-要货产品信息
    async getProdDeliveryPlan() {
      const { productCode, zzfld000001 } = this.rowData
      const params = {
        customer: this.wlyApplyForGoodsPo.customerCode,
        productCode: productCode,
        saleCenter: zzfld000001,
        brand: '',
        fhplanType: '0', // 月度计划类型：传统/团购
        planType: this.wlyApplyForGoodsPo.planType,
        channel: this.wlyApplyForGoodsPo.channelsType // 渠道类型
      }
      try {
        const res = await apiGetProdDeliveryPlan(params)
        if (res?.status === 1) {
          this.wlyApplyForGoodsPo.cancelDays = res.data.cancelDays
          const { needPlan, planQuantity, applyNum, monthLeftQty, annualLeftQty, divertQuantity, brandBq, yearSalePlanQty, monthSalePlanQty, monthAuditQty } = res.data
          params.brand = brandBq
          if (needPlan == 1 && planQuantity == 0) {
            this.errorList = ['没有编制月度计划！']
          }
          if(this.isTerminalType){
            // 初始化省份
            this.wlyApplyForGoodsPo.demandType == 'ZDZG'
            // this.getAreaArr()
            this.terminalQureyParams = {
              dealerId: this.wlyApplyForGoodsPo.customerCode,
              channelsType: this.wlyApplyForGoodsPo.channelsType,
              inventoryCode: brandBq
            }
          }
          this.gridOptions.data.forEach(item => {
            this.$set(item, 'brandBqTextView', res.data.brandBqTextView)
            this.$set(item, 'planQuantity', planQuantity)
            this.$set(item, 'productCode', this.rowData.productCode)
            this.$set(item, 'applyNum', applyNum)
            this.$set(item, 'monthLeftQty', monthLeftQty)
            this.$set(item, 'annualLeftQty', annualLeftQty)
            this.$set(item, 'divertQuantity', divertQuantity)
            this.$set(item, 'needPlan', needPlan)
            this.$set(item, 'yearSalePlanQty', yearSalePlanQty)
            this.$set(item, 'monthSalePlanQty', monthSalePlanQty)
            this.$set(item, 'monthAuditQty', monthAuditQty)
          })
        }
        const res2 = await apiGetProdMiddleStockData(params)
        if (res2?.status === 1) {
          const { stockQuantity, roadQuantity, auditShipmentQuantity } = res2.data
          // alert(roadQuantity)
          // console.log('stockQuantity==',stockQuantity)
          this.gridOptions.data.forEach(item => {
            this.$set(item, 'stockQuantity', stockQuantity)
            this.$set(item, 'roadQuantity', roadQuantity)
            this.$set(item, 'auditShipmentQuantity', auditShipmentQuantity)
          })
        }
      } catch (error) {
        //
      }
    },
    // 选择客户
    async confirmSelect() {
      this.$refs.dialogEdit.submitForm().then(async res => {
        switch (this.showDialogType) {
          case 'client':
            this.selectClient(res)
            break
          case 'contact':
            this.selectContact(res)
            break
          case 'ka':
            this.selectKA(res)
            break
          case 'Shuntclient':
            this.selectShuntclient(res)
            break
          case 'shuntContact':
            this.selectShuntContact(res)
            break
          case 'addressInfo':
            this.editAddInfo(res)
            break
          case 'terminal':
            this.editTerminalAdd(res)
            break
          case 'receiveAddress':
            this.changeStreet(res)
            break
          case 'commonReceiveAddress':
            this.changeCommonAddress(res)
            break
        }
        this.showDialog = false
      })
    },
    editAddInfo(data) {
      if (data) {
        Object.assign(this.wlyApplyForGoodsPo, data)
      }
    },
    async selectShuntContact(data) {
      console.log(data, '{{{{')
      if (data) {
        this.wlyApplyForGoodsPo.shuntReceiveUnitName = data.PARTNER_NAME
        this.wlyApplyForGoodsPo.spurtCodeUnitName = data.PARTNER_NAME
        this.wlyApplyForGoodsPo.receiveUnitName = data.PARTNER_NAME
        this.wlyApplyForGoodsPo.shuntReceiveUnitCode = data.PARTNER
        this.wlyApplyForGoodsPo.spurtCodeUnit = data.PARTNER
        this.wlyApplyForGoodsPo.receiveUnitCode = data.PARTNER
        // tel_number
        this.wlyApplyForGoodsPo.contactNumber = data.TEL_NUMBER
        // c_o_name
        this.wlyApplyForGoodsPo.contacPerson = data.C_O_NAME
        // street
        this.wlyApplyForGoodsPo.receiveAddress = data.STREET
        this.wlyApplyForGoodsPo.cityCode = data.CITY_CODE
        this.wlyApplyForGoodsPo.cityName = data.CITY_NAME
        this.wlyApplyForGoodsPo.receiveCityName = data.CITY_NAME
        this.wlyApplyForGoodsPo.receiveCityCode = data.CITY_CODE
        this.wlyApplyForGoodsPo.region = data.REGION
        this.wlyApplyForGoodsPo.streetcode = data.STREETCODE
        
        // V032普通要货申请，需要保存省市区名称和编码用于行业团购
        if (this.isV032NormalApply) {
          // 保存编码
          this.wlyApplyForGoodsPo.provinceId = data.REGION || ''
          this.wlyApplyForGoodsPo.cityId = data.CITY_CODE || ''
          this.wlyApplyForGoodsPo.districtId = data.STREETCODE || ''
          
          // 如果有名称字段，直接使用；否则根据编码查询名称
          if (data.REGION_TEXT) {
            this.wlyApplyForGoodsPo.province = data.REGION_TEXT
          } else if (data.REGION) {
            // 根据省编码查询省名称
            const regionRes = await getArea('', 'region')
            const regionItem = regionRes.DATA?.find(item => item.BLAND === data.REGION)
            this.wlyApplyForGoodsPo.province = regionItem?.BEZEI || ''
          }
          
          // 市名称
          this.wlyApplyForGoodsPo.city = data.CITY_NAME || ''
          
          // 区名称需要根据区编码查询
          if (data.STREETCODE && data.CITY_CODE) {
            const streetRes = await getArea(data.CITY_CODE, 'street')
            const streetItem = streetRes.DATA?.find(item => item.STRT_CODE === data.STREETCODE)
            this.wlyApplyForGoodsPo.district = streetItem?.MC_STREET || ''
          }
        }
      }
    },
    async selectShuntclient(data) {
      if (data) {
        if(this.isRadio){
          this.wlyApplyForGoodsPo.shuntDealer = data.customerCode
          this.wlyApplyForGoodsPo.shuntDealerName = data.customerName
        }else{
          // const data = await this.$refs.dialogSelect.submitForm()
          this.wlyApplyForGoodsPo.shuntDealer = data.shuntingCustomer
          this.wlyApplyForGoodsPo.shuntDealerName = data.shuntingCustomerName
          this.wlyApplyForGoodsPo.shuntChannelsType = data.channels
        }
      }
    },
    selectClient(data) {
      this.wlyApplyForGoodsPo.spurtCodeUnit = data.partner
      this.wlyApplyForGoodsPo.spurtCodeUnitName = data.partner_name
    },
    // 选择收货单位
    async selectContact(data) {
      this.wlyApplyForGoodsPo.receiveUnitName = data.PARTNER_NAME
      this.wlyApplyForGoodsPo.receiveUnitCode = data.PARTNER
      this.wlyApplyForGoodsPo.acceptUnitType = data.ZZFLD000016
      this.wlyApplyForGoodsPo.contacPerson = data.C_O_NAME
      this.wlyApplyForGoodsPo.contactNumber = data.TEL_NUMBER
      this.wlyApplyForGoodsPo.receiveAddress = data.STREET
      this.wlyApplyForGoodsPo.cityCode = data.CITY_CODE
      this.wlyApplyForGoodsPo.cityName = data.CITY_NAME
      this.wlyApplyForGoodsPo.receiveCityName = data.CITY_NAME
      this.wlyApplyForGoodsPo.receiveCityCode = data.CITY_CODE
      this.wlyApplyForGoodsPo.region = data.REGION
      this.wlyApplyForGoodsPo.streetcode = data.STREETCODE
      
      // V032普通要货申请，需要保存省市区名称和编码用于行业团购
      if (this.isV032NormalApply) {
        // 保存编码
        this.wlyApplyForGoodsPo.provinceId = data.REGION || ''
        this.wlyApplyForGoodsPo.cityId = data.CITY_CODE || ''
        this.wlyApplyForGoodsPo.districtId = data.STREETCODE || ''
        
        // 如果有名称字段，直接使用；否则根据编码查询名称
        if (data.REGION_TEXT) {
          this.wlyApplyForGoodsPo.province = data.REGION_TEXT
        } else if (data.REGION) {
          // 根据省编码查询省名称
          const regionRes = await getArea('', 'region')
          const regionItem = regionRes.DATA?.find(item => item.BLAND === data.REGION)
          this.wlyApplyForGoodsPo.province = regionItem?.BEZEI || ''
        }
        
        // 市名称
        this.wlyApplyForGoodsPo.city = data.CITY_NAME || ''
        
        // 区名称需要根据区编码查询
        if (data.STREETCODE && data.CITY_CODE) {
          const streetRes = await getArea(data.CITY_CODE, 'street')
          const streetItem = streetRes.DATA?.find(item => item.STRT_CODE === data.STREETCODE)
          this.wlyApplyForGoodsPo.district = streetItem?.MC_STREET || ''
        }
      }
    },
    selectKA(data) {
      const { fullName, shortName, areaName } = data
      this.wlyApplyForGoodsPo.kaStoreFullname = fullName
      this.wlyApplyForGoodsPo.kaStoreShortName = shortName
      this.wlyApplyForGoodsPo.kaStoreArea = areaName
    },
    showClientDialog(e = undefined, type) {
      // 验证选择分流收货单位时，是否选择了分流经销商
      if (type === 'shuntContact') {
        if (!this.wlyApplyForGoodsPo.shuntDealer) {
          return this.$message.error('请先选择分流经销商！')
        }
      }
      this.showDialogType = type

      e && e.target.blur()
      this.dialogTitle = {
        client: '客户选择',
        contact: '收货单位选择',
        shuntContact: '分流收货单位',
        ka: 'KA卖场',
        Shuntclient: '分流经销商',
        addressInfo: '收货信息'
      }[type]
      this.showDialog = true
    },
    closeDialog() {
      if (this.showDialogType === 'addressInfo') {
        this.wlyApplyForGoodsPo.selfacceptance = '0'
      }
      this.showDialog = false
    },
    beforeClose(done) {
      if (this.showDialogType !== 'addressInfo') {
        done()
      } else {
        this.wlyApplyForGoodsPo.selfacceptance = '0'
        done()
      }
    },
    async dowLoadFile({ file_id, id, fileName }) {
      const res = await apiAttachmentDownFile({ id: file_id || id })
      download(res.data, fileName)
    },
    async getFiles() {
      const params = {
        bizId: this.wlyApplyForGoodsPo.id,
        bizCode: this.processKey
      }
      const { data } = await queryFiles(params)
      this.gridOptions2.data = data
    },
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('bizId', this.wlyApplyForGoodsPo.fileBizId || this.wlyApplyForGoodsPo.id)
      formData.append('bizCode', this.processKey)
      formData.append('formSecretLevel', 0)
      formData.append('name', file.name)
      formData.append('type', file.raw.type)
      formData.append('lastModifiedDate', file.raw.lastModifiedDate)
      formData.append('size', file.size)
      formData.append('file', file.raw)
      const { data } = await webUploadFile(formData)
      data.file_id = data.id
      delete data.id
      this.gridOptions2.data.unshift(data)
    },
    resetLinker() {
      if (this.wlyApplyForGoodsPo.selfacceptance === 1) {
        this.showClientDialog(undefined, 'addressInfo')
      } else {
        this.wlyApplyForGoodsPo.remark = ''
      }
    },
    // 删除合同附件
    async delUpload() {
      const check = this.$refs.xTable3.getRadioRecord()
      const index = this.gridOptions2.data.findIndex(v => v._X_ID === check._X_ID)
      await deleteFiles({ id: check.file_id || check.id, isCheck: false })
      this.gridOptions2.data.splice(index, 1)
    },
    validate(cb) {
      if (this.wlyApplyForGoodsPo.region == '' || this.wlyApplyForGoodsPo.city_code == '' || this.wlyApplyForGoodsPo.streetcode == '') {
        this.errorList.push('主数据的收货地址缺少省、市、区县信息,请联系战区相关负责人！')
        return false
      }
      this.errorList = []
      let itemValid = false
      let havePlan = false
      this.gridOptions.data.forEach(item => {
        itemValid = item.wantQuantity >= 0
        if (item.needPlan == 1 && item.planQuantity == 0) {
          havePlan = true
        }
      })

      this.$refs['form'].validate((valid, err) => {
        if (valid && itemValid && !havePlan) {
          cb()
        } else if (havePlan) {
          this.errorList.push('没有编制月度计划！')
        } else if (!itemValid) {
          this.errorList.push('必须填写本次要货量！')
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    saveData() {
      this.loading = true
      const obj = {
        ...this.wlyApplyForGoodsPo
      }
      if(this.isTerminalType){
        obj.province = this.terminalAdd.REGION_TEXT || this.wlyApplyForGoodsPo.province
        obj.city = this.terminalAdd.CITY_TEXT || this.wlyApplyForGoodsPo.city
        obj.district = this.terminalAdd.STREET_TEXT || this.wlyApplyForGoodsPo.district
      }else{
        obj.demandType = 'none'
        // V032普通要货申请，传递省市区信息（无论是否自定义地址，都需要传递）
        if (this.isV032NormalApply) {
          obj.region = this.wlyApplyForGoodsPo.region
          obj.cityCode = this.wlyApplyForGoodsPo.cityCode
          obj.cityName = this.wlyApplyForGoodsPo.cityName
          obj.streetcode = this.wlyApplyForGoodsPo.streetcode
          // 行业团购需要传递省市区名称及编码
          // 如果渠道类型为H（行业团购），必须传递省市区名称及编码
          if (this.wlyApplyForGoodsPo.channelsType === 'H') {
            obj.province = this.wlyApplyForGoodsPo.province || ''
            obj.city = this.wlyApplyForGoodsPo.city || ''
            obj.district = this.wlyApplyForGoodsPo.district || ''
            obj.provinceId = this.wlyApplyForGoodsPo.provinceId || this.wlyApplyForGoodsPo.region || ''
            obj.cityId = this.wlyApplyForGoodsPo.cityId || this.wlyApplyForGoodsPo.cityCode || ''
            obj.districtId = this.wlyApplyForGoodsPo.districtId || this.wlyApplyForGoodsPo.streetcode || ''
          }
        }
      }
      const params = JSON.parse(JSON.stringify(obj))
      handlerFlow(params, this.processKey)
        .then(async response => {
          this.loading = false
          // if (!this.wlyApplyForGoodsPo.id) {
          this.startflow(response.data)
          // }
          if (response.status == 1) {
            this.$message.success('保存成功！')
          }
          // await advance(this.wlyApplyForGoodsPo)
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 提交成功
    advanceSuccess(id) {
      if (id) {
        this.id = id
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
.edit-add{
  color: #333;
  font-size: 12px;
  line-height: 24px;
  margin-left: 12px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/ToGoods.vue